import { useEffect } from 'react';
import { useAmplitudeReplays } from 'shared/hooks/analytics/amplitude/useAmplitudeReplays';

const AmplitudeSessionReplay = () => {
  const initializeAmplitudeReplay = useAmplitudeReplays();

  useEffect(() => {
    initializeAmplitudeReplay();
  }, [initializeAmplitudeReplay]);

  return null;
};

export default AmplitudeSessionReplay;
